import { Uploader } from './view';
export default Uploader;
